import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';

const PageHero = ({ badge, badgeIcon: BadgeIcon, title, highlightWord, subtitle, breadcrumb }) => {
  return (
    <>
      {/* Breadcrumb Bar - Prominent "Back to Home" */}
      <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-green-600 text-white py-3 shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm px-4 py-2 rounded-lg font-semibold text-sm transition-all hover:scale-105 border border-white/20"
            >
              <Home className="w-4 h-4" />
              Back to Homepage
            </Link>
            <div className="flex items-center gap-2 text-sm text-white/90">
              <Link to="/" className="hover:text-amber-300 transition-colors">Home</Link>
              <ChevronRight className="w-4 h-4" />
              <span className="font-semibold">{breadcrumb}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Mini Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-amber-50 py-12 md:py-16 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-200/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            {badge && (
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                {BadgeIcon && <BadgeIcon className="w-4 h-4" />}
                {badge}
              </div>
            )}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 leading-tight">
              {title}{' '}
              {highlightWord && (
                <span className="bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent">
                  {highlightWord}
                </span>
              )}
            </h1>
            {subtitle && (
              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">{subtitle}</p>
            )}
            <div className="mt-6 inline-flex items-center gap-3 bg-white rounded-full px-6 py-3 shadow-lg border border-gray-100">
              <span className="text-sm text-gray-600">Explore our complete offerings:</span>
              <Link
                to="/"
                className="inline-flex items-center gap-1 text-blue-600 font-semibold text-sm hover:text-blue-700 transition-colors"
              >
                Visit Homepage <ChevronRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageHero;
